<div class="group/tooltip relative flex-col items-center" [ngClass]="fullWidth ? 'flex w-full min-w-0' : 'inline-flex'">
  <div class="relative flex justify-center" [ngClass]="fullWidth ? 'w-full min-w-0' : 'inline-flex'">
    <ng-content></ng-content>
  </div>

  @if (text && text.trim()) {
  <div class="fixed whitespace-nowrap rounded-md py-1.5 px-3.5 text-sm text-white 
              bg-secundary-b300 opacity-0 transition-opacity w-max pointer-events-none
              group-hover/tooltip:opacity-100" style="z-index: 9999;">

    {{ text }}

    @if (position === 'top') {
    <div class="absolute left-1/2 -translate-x-1/2 flex justify-center"
      style="bottom:-0.25rem">
      <span class="w-2 h-2 rotate-45 bg-secundary-b300 pointer-events-none"></span>
    </div>
    }
    @if (position === 'bottom') {
    <span class="absolute w-2 h-2 rotate-45 bg-secundary-b300 pointer-events-none -top-1 left-1/2 -translate-x-1/2"></span>
    }
  </div>
  }
</div>